import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initializeLocale } from './i18n';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

async function start() {
  try {
    await initializeLocale();
    root.render(<React.StrictMode><App /></React.StrictMode>);
  } catch (_) {
    // Translation chunks can fail while offline or during a deployment. Avoid
    // rendering untranslated keys and allow retrying without losing the URL.
    root.render(<div role="alert" dir="ltr" lang="en">
      <p>Unable to load the application language. Check your connection and try again.</p>
      <button onClick={start}>Try again</button>
    </div>);
  }
}
start();
reportWebVitals();
